// 🔧 school_elections.js
// ✅ Purpose: Marketing landing page wrapper for school elections
// ✅ Features:
// - Pulls SEO and page content from centralized marketing_pages.js
// - Renders shared SEO-focused IndustryLandingPage template

import React from "react";
import IndustryLandingPage from "./industry_landing_page";
import { MARKETING_PAGES } from "../../constants/marketing_pages";

const SchoolElections = () => {
  return <IndustryLandingPage page={MARKETING_PAGES.schoolElections} />;
};

export default SchoolElections;